import { renderRequiredRule } from "@/utils/renderRulesForm";

export default () => ({
  whoPaysForCargoPickup: [],
  typeOfPaymentForCargoPickup: [],
  whoPaysForCargoTransportation: [],
  typeOfPaymentForCargoTransportation: [],
  whoPaysForCargoDelivery: [],
  typeOfPaymentForCargoDelivery: [],
  whoPaysForCargoExtraPacking: [],
  typeOfPaymentForCargoExtraPacking: [],

  isAgreeDataProcessing: [renderRequiredRule("")],
  isAgreeEmailMailing: [],
});
// {
//   validator: (rule, value, callback) => {
//     if (services.dataForTheDriver && value === "") {
//       callback(new Error("Пожалуйста выберите способ"));
//     }
//     callback();
//   },
//   trigger: "blur",
// },
